/**
 * Display helpers for CPR. Never log or return plaintext unless the caller
 * already decrypted via decrypt-cpr.
 */

export const MASKED_CPR = '••••••-••••';

export function formatRevealedCpr(cpr: string): string {
  const digits = cpr.replace(/\D/g, '');
  if (digits.length >= 10) return `${digits.slice(0, 6)}-${digits.slice(6, 10)}`;
  return cpr;
}

/** Age from a decrypted 10-digit CPR. Returns null if the value is not usable. */
export function ageYearsFromCpr(cpr: string, now = new Date()): number | null {
  const digits = cpr.replace(/\D/g, '');
  if (digits.length < 10) return null;
  const day = Number(digits.slice(0, 2));
  const month = Number(digits.slice(2, 4));
  const yy = Number(digits.slice(4, 6));
  const serial = Number(digits.slice(6, 10));
  if (!day || month < 1 || month > 12) return null;

  let century = 1900;
  if (serial >= 5000 && serial <= 8999 && yy >= 37) century = 1800;
  else if (serial >= 4000 && yy <= 36) century = 2000;
  else if (serial >= 5000 && serial <= 8999 && yy <= 57) century = 2000;

  const birth = new Date(century + yy, month - 1, day);
  if (Number.isNaN(birth.getTime()) || birth.getDate() !== day) return null;
  let age = now.getFullYear() - birth.getFullYear();
  const monthDiff = now.getMonth() - birth.getMonth();
  if (monthDiff < 0 || (monthDiff === 0 && now.getDate() < birth.getDate())) age -= 1;
  return age >= 0 && age < 130 ? age : null;
}
